import { render, staticRenderFns } from "./VenueSpecialOffers.vue?vue&type=template&id=fc224d24&"
import script from "./VenueSpecialOffers.vue?vue&type=script&lang=js&"
export * from "./VenueSpecialOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports